// @ts-nocheck
import React, { useState } from 'react';
import { useDifusiones } from '../../../context/DifusionesContext';
import AlertMessage from '../../../../Alias/AlertMessage';
import { useAreas } from '../../../../Areas/State/AreasContext';
import { useAlias } from '../../../../Alias/State/AliasContext';
import {
    InputLabel,
    ListSubheader,
    MenuItem,
    FormControl,
    Select,
    Box,
    Slide,
    Alert,
    Switch,
    FormControlLabel,
    Collapse,
    Tooltip,
    Typography,
    IconButton,
    TextField,
} from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import EditIcon from '@mui/icons-material/Edit';
import KeyCloak from '../../../../Auth/Keycloak';
import { EditarNombreAliasModal } from './EditarNombreAliasModal';
import SolicitarNoReply from './SolicitarNoReply';

function SeleccionarAlias({ alias, alert, setAlert, direccion, noReplysMails, areasUser = [], setForm, form, setAliasLimitadas }) {
    const { obtenerFirmaAlias, alcanzoLimiteAlias } = useDifusiones();
    const { getArea } = useAreas();
    const { getAlias } = useAlias();
    const [replyToEnabled, setReplyToEnabled] = useState(false);
    const [aliasToEdit, setAliasToEdit] = useState(null);
    const [openEditarNombre, setOpenEditarNombre] = useState(false);

    const isNoReply = (mail) => noReplysMails.some(item => item.email === mail);

    const handleChange = ({ target }) => {
        if (isNoReply(target.value)) {
            const noReplyAlias = noReplysMails.find(a => a.email === target.value);
            setForm({ ...form, alias: target.value, aliasNombre: "", firma: "", area: noReplyAlias.areaId, area_nombre: "" });
            setAliasToEdit(null);
            Promise.all([
                getArea(noReplyAlias.areaId),
                alcanzoLimiteAlias(target.value),
            ]).then(([area, habilitado]) => {
                setAliasLimitadas(habilitado ? [] : [target.value]);
                setForm(prev => ({ ...prev, area_nombre: area?.path ?? '' }));
            });
        } else {
            const selectedAlias = alias.find(a => a.mail === target.value);
            setForm({ ...form, alias: selectedAlias.mail, aliasNombre: selectedAlias.nombre, firma: null, area: selectedAlias.area, area_nombre: "" });
            setAliasToEdit(selectedAlias);
            Promise.all([
                obtenerFirmaAlias(selectedAlias.nombre),
                getAlias(selectedAlias.mail),
                alcanzoLimiteAlias(selectedAlias.mail),
            ]).then(([aliasInfo, aliasData, habilitado]) => {
                setAliasLimitadas(habilitado ? [] : [selectedAlias.mail]);
                setForm(prev => ({
                    ...prev,
                    firma: aliasInfo[0],
                    area_nombre: aliasData?.[0]?.area?.nombre?.toString() ?? ''
                }));
            });
        }
    };

    const handleReplyToToggle = () => {
        const enabling = !replyToEnabled;
        setReplyToEnabled(enabling);
        if (!enabling) {
            setForm(prev => ({ ...prev, replyTo: "" }));
        }
    };

    const handleReplyToChange = ({ target }) => {
        setForm(prev => ({ ...prev, replyTo: target.value }));
    };

    const canEdit = KeyCloak.hasRole(['ROLE_MODIFICAR_ALIAS']);
    const selectedIsRegular = form.alias && !isNoReply(form.alias);

    return (
        <Slide direction={direccion} in={true} mountOnEnter unmountOnExit>
            <Box sx={{ minWidth: 120, display: 'flex', flexDirection: 'column', gap: 2 }}>
                <AlertMessage alert={alert} setAlert={setAlert} />

                {alias?.length === 0 && noReplysMails?.length === 0 && (
                    <Alert severity="warning">
                        No tenés alias disponibles para enviar difusiones.
                    </Alert>
                )}

                <FormControl fullWidth>
                    <InputLabel id="select-alias">Alias remitente</InputLabel>
                    <Select
                        labelId="select-alias"
                        id="select-alias-input"
                        value={form.alias || ''}
                        label="Alias remitente"
                        onChange={handleChange}
                        disabled={alias?.length === 0 && noReplysMails?.length === 0}
                    >
                        {alias?.length > 0 && <ListSubheader>Alias</ListSubheader>}
                        {alias?.map(unAlias => (
                            <MenuItem key={unAlias.nombre} value={unAlias.mail}>
                                {unAlias.mail}
                            </MenuItem>
                        ))}
                        {noReplysMails?.length > 0 && <ListSubheader>No-replys</ListSubheader>}
                        {noReplysMails?.map(noReply => (
                            <MenuItem key={noReply.id} value={noReply.email}>
                                {noReply.email}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>

                {areasUser.length > 0 && (
                    <SolicitarNoReply areas={areasUser} />
                )}

                <Collapse in={selectedIsRegular}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <TextField
                            label="Nombre remitente"
                            value={form.aliasNombre || ''}
                            InputProps={{ readOnly: true }}
                            variant="outlined"
                            sx={{
                                flexGrow: 1,
                                '& .MuiOutlinedInput-root': { bgcolor: '#f5f5f5' },
                                '& input': { cursor: 'default', color: 'text.secondary' },
                            }}
                        />
                        <Tooltip title={`Este nombre aparecerá en el campo 'De' del correo, en este caso: ${form.aliasNombre || 'Nombre'} <${form.alias || ''}>`}>
                            <InfoOutlinedIcon fontSize="small" color="action" sx={{ flexShrink: 0, cursor: 'pointer' }} />
                        </Tooltip>
                        {canEdit ? (
                            <Tooltip title="Editar nombre del alias">
                                <IconButton size="small" onClick={() => setOpenEditarNombre(true)}>
                                    <EditIcon fontSize="small" />
                                </IconButton>
                            </Tooltip>
                        ) : (
                            <Tooltip title="Necesitás el rol ROLE_MODIFICAR_ALIAS para editar. Solicitalo al soporte.">
                                <span>
                                    <IconButton size="small" disabled>
                                        <EditIcon fontSize="small" />
                                    </IconButton>
                                </span>
                            </Tooltip>
                        )}
                    </Box>
                </Collapse>

                <FormControlLabel
                    control={
                        <Switch
                            checked={replyToEnabled}
                            onChange={handleReplyToToggle}
                            disabled={!alias?.length}
                        />
                    }
                    label={
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                            <Typography variant="body2">Redirigir respuestas</Typography>
                            <Tooltip title="Cuando el destinatario responda el correo, la respuesta llegará al alias seleccionado en lugar del remitente. El destinatario no verá esta dirección.">
                                <InfoOutlinedIcon fontSize="small" color="action" />
                            </Tooltip>
                        </Box>
                    }
                />

                <Collapse in={replyToEnabled}>
                    <FormControl fullWidth>
                        <InputLabel id="select-reply-to">Alias de respuesta</InputLabel>
                        <Select
                            labelId="select-reply-to"
                            value={form.replyTo || ''}
                            label="Alias de respuesta"
                            onChange={handleReplyToChange}
                        >
                            {alias?.map(unAlias => (
                                <MenuItem key={unAlias.nombre} value={unAlias.mail}>
                                    {unAlias.mail}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Collapse>

                <EditarNombreAliasModal
                    open={openEditarNombre}
                    onClose={() => setOpenEditarNombre(false)}
                    aliasMail={form.alias}
                    aliasNombreInicial={form.aliasNombre}
                    aliasData={aliasToEdit}
                    onSuccess={(nuevoNombre) => {
                        setForm(prev => ({ ...prev, aliasNombre: nuevoNombre }));
                        setAliasToEdit(prev => prev ? { ...prev, nombre: nuevoNombre } : prev);
                    }}
                />
            </Box>
        </Slide>
    );
}

export default SeleccionarAlias;
